
import { AssessmentResponse, AssessmentResult } from '@/types/assessment';
import { toast } from 'sonner';

/**
 * Saves responses to localStorage
 */
export const saveResponsesToLocalStorage = (userId: string, responses: AssessmentResponse[]): void => {
  try {
    localStorage.setItem(`responses_${userId}`, JSON.stringify(responses));
    console.log('Responses saved to localStorage for user ID:', userId);
  } catch (error) {
    console.error('Error saving to localStorage:', error);
    toast.error('Failed to save responses locally');
  }
};

/**
 * Gets responses from localStorage
 */
export const getResponsesFromLocalStorage = (userId: string): AssessmentResponse[] | null => {
  try {
    const stored = localStorage.getItem(`responses_${userId}`);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch (error) {
    console.error('Error retrieving from localStorage:', error);
    return null;
  }
};

/**
 * Saves a result to localStorage
 */
export const saveResultToLocalStorage = (userId: string, result: AssessmentResult): void => {
  try {
    localStorage.setItem(`report_${userId}`, JSON.stringify(result));
    console.log('Result saved to localStorage for user ID:', userId);
  } catch (error) {
    console.error('Error saving result to localStorage:', error);
  }
};

/**
 * Gets a result from localStorage
 */
export const getResultFromLocalStorage = (userId: string): AssessmentResult | null => {
  try {
    const stored = localStorage.getItem(`report_${userId}`);
    if (!stored) return null;
    return JSON.parse(stored);
  } catch (error) {
    console.error('Error retrieving result from localStorage:', error);
    return null;
  }
};
